<template>
  <div v-loading="loading" class="admin">
    <h2>Editar Usuário</h2>
    <div class="content" :label-position="right">
      <el-form ref="form" :model="user" label-width="140px" label="right">
        <el-row>
          <el-col :lg="8" :offset="8">
            <el-form-item label="Username">
              <el-input v-model="user.username" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :offset="8">
            <el-form-item label="Email">
              <el-input v-model="user.email" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="6" :offset="8">
            <el-form-item label="Data de Nascimento">
              <el-date-picker
                id="birth-date"
                format="DD/MM/YYYY"
                v-model="user.birthDate"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :offset="8">
            <el-form-item label="Tipo de Usuário">
              <el-select v-model="user.user_type" placeholder="Selecione">
                <el-option
                  v-for="type in user_type_options"
                  :key="type.value"
                  :label="type.label"
                  :value="type.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="8" :offset="8">
            <el-form-item class="form-buttons">
              <el-button type="warning" @click="updateUserType"
                >Editar</el-button
              >
              <el-button type="danger" @click="deleteUser">Deletar</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getUser, updateUserType, deleteUser } from "../../../services/user";
export default {
  name: "Details",
  data() {
    return {
      user: {},
      user_type_options: [
        { value: "user", label: "Usuário" },
        { value: "moderator", label: "Moderador" },
        { value: "admin", label: "Administrador" },
      ],
    };
  },
  methods: {
    async updateUserType() {
      const response = await updateUserType(this.$route.params.id, {
        user_type: this.user.user_type,
      });
      if (response.status === 204) {
        this.$message.success("Tipo de usuário atualizado com sucesso!");
        this.$router.push(`/admin/users`);
      }
    },
    async getUser(id) {
      const response = await getUser(id);
      this.user = response.data;
    },
    async deleteUser() {
      const shouldDelete = await this.$confirm(
        "Essa é uma operação definitiva. Tem certeza que deseja continuar?",
        "Atenção",
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      );
      if (shouldDelete) {
        const response = await deleteUser(this.user._id.$oid);
        if (response.status === 204) {
          this.$message.success("Usuário deletado com sucesso!");
          this.$router.push(`/admin/users`);
        }
      }
    },
  },
  created() {
    this.getUser(this.$route.params.id);
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}

.admin {
  margin: 30px;
}

#birth-date {
  width: 100%;
}

.form-buttons {
  float: right;
}
</style>
